module.exports = __webpack_public_path__ + "static/media/brand-vibes-bottom.6b1bd61a.png";